import { Component, h, Listen, Prop, State, Element, Host } from '@stencil/core';
import { ButtonType } from '../../enums/ButtonType.enum';

@Component({
  tag: 'pnk-button',
  styleUrl: 'pnk-button.css',
})
export class PnkButton {
  @Prop() type: ButtonType = ButtonType.Primary;

  @Prop() disabled: boolean = false;

  @Prop() icon: string | undefined;

  @State() iconClass: string;

  @Element() host!: HTMLElement;

  constructor() {
    this.iconClass = this.host.innerText;
  }

  @Listen('click', { capture: true }) handleClick(ev: MouseEvent) {
    if (this.disabled) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }

  componentDidLoad() {
    this.iconClass = this.icon ? this.icon : this.host.innerText;
    if (this.host.innerText.length > 0) {
      this.host.firstChild?.remove();
    }
  }

  getClassByType() {
    const classes = ['pnk-text-base pnk-font-base flex flex-row'];

    switch (this.type) {
      case ButtonType.Primary:
        classes.push('pnk-px-5 pnk-py-2.5');
        if (this.disabled) {
          classes.push('pnk-bg-disabled-base pnk-text-disabled-text pnk-rounded');
        } else {
          classes.push('pnk-bg-primary-base pnk-text-white hover:pnk-bg-primary-hover pnk-rounded');
        }
        break;
      case ButtonType.Secondary:
        classes.push('pnk-px-5 pnk-py-2.5');
        if (this.disabled) {
          classes.push('pnk-bg-disabled-base pnk-text-disabled-text pnk-rounded');
        } else {
          classes.push('pnk-bg-secondary-base pnk-text-primary-base hover:pnk-bg-secondary-hover hover:pnk-text-white pnk-rounded');
        }
        break;
      case ButtonType.Text:
        classes.push('pnk-px-5 pnk-py-2.5 pnk-rounded');
        if (this.disabled) {
          classes.push('pnk-text-disabled-text');
        } else {
          classes.push('pnk-text-primary-base hover:pnk-text-primary-hover');
        }
        break;
      case ButtonType.Round:
        classes.push('pnk-text-disabled-text flex flex-row pnk-rounded-full pnk-w-[30px] pnk-h-[30px] pnk-bg-surface pnk-items-center pnk-justify-center');
        if (!this.disabled) {
          classes.push(' hover:pnk-bg-primary-hover hover:pnk-text-white ');
        }
        break;
      default:
        break;
    }

    return classes.join(' ');
  }

  render() {
    return (
      <Host>
        <button class={this.getClassByType()} disabled={this.disabled}>
          {this.icon ? <pnk-icon class={'w-full'} icon={this.icon}></pnk-icon> : null}
          <slot></slot>
        </button>
      </Host>
    );
  }
}
